import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
import AOS from "aos";
import "aos/dist/aos.css";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
import VerticalAds from "../../Admin/Pages/VerticleAds";
export default function House() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);
  const navigate = useNavigate();

  const [searchCity, setSearchCity] = useState("");

  const [wishlist, setWishlist] = useState([]);
  const [user, setUser] = useState(null);
  const [minRent, setMinRent] = useState("");
  const [maxRent, setMaxRent] = useState("");
  const [searchState, setSearchState] = useState("");
  const [houses, setHouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageIndexes1, setImageIndexes1] = useState({});
  const nextImage1 = (e, item, images) => {
    e.stopPropagation();

    const current = imageIndexes1[item.id] || 0;

    if (current >= images.length - 1) {
      navigate(`/houserentdetails/${item.id}`);
      return;
    }

    setImageIndexes1((prev) => ({
      ...prev,
      [item.id]: current + 1,
    }));
  };

  const prevImage1 = (e, item) => {
    e.stopPropagation();

    const current = imageIndexes1[item.id] || 0;

    if (current === 0) return;

    setImageIndexes1((prev) => ({
      ...prev,
      [item.id]: current - 1,
    }));
  };
  /* =========================
      1. PAGINATION STATE
     ========================= */
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(40); // Adjust this number as needed

  /* =========================
      2. FETCH HOUSES
     ========================= */
  const fetchHouses = useCallback(async (showLoading = true) => {
    if (showLoading) {
      setLoading(true);
    }

    try {
      const res = await fetch(
        `${API.LIST_ACTIVE_WORKSPACES}&t=${new Date().getTime()}`,
      );

      const data = await res.json();

      setHouses(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Fetch Error:", error);
      setHouses([]);
    } finally {
      if (showLoading) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    // First load with loading
    fetchHouses(true);

    // Background refresh without loading
    const interval = setInterval(() => {
      fetchHouses(false);
    }, 5000);

    // When user comes back to tab, show loading
    const handleFocus = () => {
      fetchHouses(true);
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", handleFocus);
    };
  }, [fetchHouses]);
  /* =========================
      3. LOAD USER & WISHLIST SYNC
     ========================= */
  const loadUserAndWishlist = useCallback(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));
    setUser(loginUser);

    if (loginUser) {
      const savedWishlist =
        JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
      setWishlist(savedWishlist);
    } else {
      setWishlist([]);
    }
  }, []);

  useEffect(() => {
    loadUserAndWishlist();
    window.addEventListener("cartUpdated", loadUserAndWishlist);
    window.addEventListener("storage", loadUserAndWishlist);

    return () => {
      window.removeEventListener("cartUpdated", loadUserAndWishlist);
      window.removeEventListener("storage", loadUserAndWishlist);
    };
  }, [loadUserAndWishlist]);

  /* =========================
      4. FRONT-END FILTERS
     ========================= */
  const filteredHouses = houses.filter((item) => {
    const matchesCity = item.city
      ?.toLowerCase()
      .includes(searchCity.toLowerCase());
    const matchesState = item.state
      ?.toLowerCase()
      .includes(searchState.toLowerCase());

    let matchesPrice = true;

    const rent = parseInt(item.rent_price);

    // Radio filters

    // Custom Min Max Filter
    if (minRent) matchesPrice = matchesPrice && rent >= Number(minRent);
    if (maxRent) matchesPrice = matchesPrice && rent <= Number(maxRent);

    return matchesCity && matchesState && matchesPrice;
  });

  // Reset to page 1 when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchCity, searchState, itemsPerPage, minRent, maxRent]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentHouses = filteredHouses.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredHouses.length / itemsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* =========================
      6. TOGGLE WISHLIST
     ========================= */
  const toggleWishlist = (house) => {
    if (!user) {
      alert("Please login first");
      return;
    }
    const storageKey = `wishlist_${user.id}`;
    let savedWishlist = JSON.parse(localStorage.getItem(storageKey)) || [];

    const exists = savedWishlist.find(
      (item) => item.id === house.id && item.type === "house",
    );

    if (exists) {
      savedWishlist = savedWishlist.filter(
        (item) => !(item.id === house.id && item.type === "house"),
      );
    } else {
      savedWishlist.push({ ...house, type: "house" });
    }

    localStorage.setItem(storageKey, JSON.stringify(savedWishlist));
    setWishlist(savedWishlist);
    window.dispatchEvent(new Event("cartUpdated"));
  };
  const getPagination = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    pages.push(1);

    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    if (currentPage <= 3) {
      start = 2;
      end = 5;
    }

    if (currentPage >= totalPages - 2) {
      start = totalPages - 4;
      end = totalPages - 1;
    }

    if (start > 2) {
      pages.push("...");
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 1) {
      pages.push("...");
    }

    pages.push(totalPages);

    return pages;
  };
  return (
    <div className="shop-page container-fluid py-4">
      <div className="row">
        {/* LEFT FILTER */}
        <div className="col-lg-2 d-none d-lg-block" data-aos="fade-right">
          <div className="filter-sidebar shadow-sm p-3 bg-white rounded sticky-top">
            {/* <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Filters</h5>
              <button
                className="btn btn-sm text-danger p-0"
                onClick={() => {
                  setMinRent("");
                  setMaxRent("");
                  setSearchState("");
                  setSearchCity("");
                }}
                style={{ fontSize: "0.8rem", fontWeight: "600" }}
              >
                CLEAR ALL
              </button>
            </div> */}
            <div className="d-flex justify-content-between align-items-center mb-4 filter-header-border">
              <h5 className="mb-0 fw-bold text-secondary text-uppercase tracking-wider fs-6">
                Filters
              </h5>
              <button
                className="btn-uniq-reset"
                onClick={() => {
                  setMinRent("");
                  setMaxRent("");
                  setSearchState("");
                  setSearchCity("");
                }}
              >
                Clear All
              </button>
            </div>
            <div className="filter-box mt-3">
              <div className="mt-3">
                <h6>Custom Rent</h6>

                <input
                  type="number"
                  placeholder="Min Rent"
                  className="form-control mb-2"
                  value={minRent}
                  onChange={(e) => setMinRent(e.target.value)}
                />

                <input
                  type="number"
                  placeholder="Max Rent"
                  className="form-control"
                  value={maxRent}
                  onChange={(e) => setMaxRent(e.target.value)}
                />
              </div>
            </div>

            <div className="filter-box mt-4">
              <h6>City</h6>
              <input
                type="text"
                placeholder="Search City"
                className="form-control"
                value={searchCity}
                onChange={(e) => setSearchCity(e.target.value)}
              />
            </div>

            <div className="filter-box mt-4">
              <h6>State</h6>
              <input
                type="text"
                placeholder="Search State"
                className="form-control"
                value={searchState}
                onChange={(e) => setSearchState(e.target.value)}
              />
              <div className="sidebar-ad">
                <div className="small text-center fw-bold p-1">SPONSORED</div>

                <VerticalAds />
              </div>
              {/* <button
                className="btn btn-sm btn-link p-0 mt-2"
                onClick={() => {
                  setMinRent("");
                  setMaxRent("");
                  setSearchState("");
                  setSearchCity("");
                }}
              >
                Clear All
              </button> */}
            </div>
          </div>
        </div>
        {/* MOBILE HORIZONTAL FILTER */}
        <div className="d-lg-none mb-3">
          <div className="mobile-filter-bar">
            <input
              type="number"
              placeholder="Min ₹"
              className="mobile-search"
              value={minRent}
              onChange={(e) => setMinRent(e.target.value)}
            />

            <input
              type="number"
              placeholder="Max ₹"
              className="mobile-search"
              value={maxRent}
              onChange={(e) => setMaxRent(e.target.value)}
            />

            <input
              type="text"
              placeholder="Search City"
              className="mobile-search"
              value={searchCity}
              onChange={(e) => setSearchCity(e.target.value)}
            />
            <input
              type="text"
              placeholder="Search State"
              className="mobile-search"
              value={searchState}
              onChange={(e) => setSearchState(e.target.value)}
            />
          </div>
        </div>
        {/* CENTER CONTENT */}
        <div className="col-lg-10">
          <div
            className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2"
            data-aos="fade-down"
          >
            <h2 className="section-title mb-0">Available Work Rooms</h2>

            <div className="d-flex align-items-center gap-3">
              {/* <p className="text-muted small mb-0">
      {filteredHouses.length} Rooms found
    </p> */}

              <div className="d-flex align-items-center gap-2">
                {/* <span className="small text-muted">Show</span> */}

                <select
                  className="form-select form-select-sm"
                  style={{ width: "80px" }}
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(parseInt(e.target.value))}
                >
                  <option value={20}>20</option>
                  <option value={40}>40</option>
                  <option value={60}>60</option>
                  <option value={100}>100</option>
                </select>

                {/* <span className="small text-muted">per page</span> */}
              </div>
            </div>
          </div>

          {loading ? (
            <div className="house-loading-container">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>

              <p className="mt-3 mb-0 text-muted">
                Loading available work rooms...
              </p>
            </div>
          ) : (
            <div className="designs-grid">
              {currentHouses.length > 0 ? (
                currentHouses.map((item, index) => {
                  const images = item.image ? item.image.split(",") : [];
                  const isLiked = wishlist.some(
                    (w) => w.id === item.id && w.type === "house",
                  );

                  return (
                    <div
                      className="design-card"
                      key={item.id}
                      onClick={() => navigate(`/houserentdetails/${item.id}`)}
                      data-aos="zoom-in-up"
                      data-aos-delay={(index % 8) * 70}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.WORKSPACE_IMAGE}${images[imageIndexes1[item.id] || 0]}`}
                          alt="workroom"
                        />
                        {images.length > 1 && (
                          <>
                            {(imageIndexes1[item.id] || 0) > 0 && (
                              <button
                                className="img-arrow left-arrow"
                                onClick={(e) => prevImage1(e, item)}
                              >
                                <i className="bi bi-chevron-left"></i>
                              </button>
                            )}

                            <button
                              className="img-arrow right-arrow"
                              onClick={(e) => nextImage1(e, item, images)}
                            >
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </>
                        )}
                        {images.length > 1 && (
                          <div className="image-count">
                            <i className="bi bi-images me-1"></i>+
                            {images.length - 1}
                          </div>
                        )}
                        {/* <span className="heads-badge">{item.floor} </span> */}
                      </div>

                      <div className="machine-body">
                        <h4 className="machine-name">{item.location}</h4>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {parseInt(item.rent_price).toLocaleString(
                                "en-IN",
                              )}
                            </span>
                            <span className="rent-unit"> </span>
                          </div>
                        </div>

                        <div className="spec-row mt-0 mb-0">
                          <div className="spec-item">
                            <span className="spec-label">Size:</span>
                            <span className="spec-value"> {item.size} </span>
                          </div>
                          <div className="spec-item">
                            <span className="spec-label">Floor:</span>
                            <span className="spec-value"> {item.floor}</span>
                          </div>
                        </div>

                        <div className="location-info">
                          <i className="bi bi-geo-alt-fill"></i>
                          {item.city},{item.state}
                        </div>

                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={(e) => {
                              e.stopPropagation();

                              navigate(`/houserentDetails/${item.id}`, {
                                state: {
                                  activeTab: "ownerInfo",
                                },
                              });
                            }}
                          >
                            <i className="bi bi-telephone-fill me-1"></i>{" "}
                            Contact Owner
                          </button>
                          {/* <button
                          className="footer-like-btn"
                          onClick={() => toggleWishlist(item)}
                        >
                          <i
                            className={
                              isLiked
                                ? "bi bi-heart-fill text-danger"
                                : "bi bi-heart"
                            }
                          ></i>
                        </button> */}
                          <button
                            className="footer-like-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleWishlist(item);
                            }}
                          >
                            <i
                              className={`bi ${isLiked ? "bi-heart-fill text-danger" : "bi-heart"}`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center w-100 py-5">
                  <i
                    className="bi bi-house-x text-muted mb-3"
                    style={{ fontSize: "3rem" }}
                  ></i>

                  <p className="text-muted">No workspaces found.</p>

                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {
                      setMinRent("");
                      setMaxRent("");
                      setSearchState("");
                      setSearchCity("");
                    }}
                  >
                    Clear all filters
                  </button>
                </div>
              )}
            </div>
          )}
          {/* ================= PAGINATION UI ================= */}
          <div className="d-flex justify-content-center mt-5">
            <ul className="pagination uniq-pagination-wrapper shadow-sm p-1 rounded-pill bg-white">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link rounded-pill"
                  onClick={() => paginate(currentPage - 1)}
                >
                  &lsaquo; Previous
                </button>
              </li>

              {getPagination().map((page, index) =>
                page === "..." ? (
                  <li key={`dots-${index}`} className="page-item disabled">
                    <span className="page-link border-0 bg-transparent">
                      ...
                    </span>
                  </li>
                ) : (
                  <li
                    key={page}
                    className={`page-item ${currentPage === page ? "active" : ""}`}
                  >
                    <button
                      className="page-link rounded-circle"
                      onClick={() => paginate(page)}
                    >
                      {page}
                    </button>
                  </li>
                ),
              )}

              <li
                className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
              >
                <button
                  className="page-link rounded-pill"
                  onClick={() => paginate(currentPage + 1)}
                >
                  Next &rsaquo;
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* RIGHT ADS */}
        {/* <div className="col-lg-2">
          <div className="ads-sidebar p-3 bg-white shadow-sm rounded text-center sticky-top">
            <h5 className="ads-title">Sponsored</h5>
            <div className="ad-card mt-3">
              <div className="ad-placeholder">
                <p className="small text-muted">Your Ad Here</p>
              </div>
              <p className="small mt-2">Premium Threads Sale!</p>
            </div>
          </div>
        </div> */}
      </div>

      <style>{`
        .custom-pagination .page-link {
          color: #00a699;
          border: 1px solid #dee2e6;
          margin: 0 3px;
          border-radius: 4px;
          font-weight: 500;
        }
        .custom-pagination .page-item.active .page-link {
          background-color: #00a699;
          border-color: #00a699;
          color: white;
        }
        .custom-pagination .page-link:hover {
          background-color: #f1f1f1;
          color: #00847a;
        }
      `}</style>
    </div>
  );
}
